import styled from 'styled-components';

import { Content as ModalContent } from '~/components/Modal/styles';
import colors from '~/styles/colors';
import grid from '~/styles/grid';

export const InputChips = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 5px;
  border: 1px solid ${colors.gray};
  background: transparent;
  height: 50px;
  padding: 5px 15px;
  transition: border 0.3s;
`;

export const Search = styled.a`
  position: absolute;
  margin-left: 88%;
  margin-top: 12px;
  color: ${colors.gray};
  cursor: pointer;

  &:hover {
    color: ${colors.primary};
  }
`;

export const RequiredText = styled.p`
  text-align: right;
  color: #f10f10;
  margin: ${grid.xl} 0 ${grid.sm} 0;
`;

export const StyledForm = styled.form`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  row-gap: ${grid.md};
`;

export const DynamicTableContainer = styled.div`
  ${ModalContent} {
    min-width: 80%;
    height: 80%;
    padding: ${grid.lg};
  }
`;
